export default {
  meta: {
    title: '需求详情'
  }
};
